import api from "../services/api";

import { IConference, IKit, IConferenceSectorManager, IConferenceRegionalManager } from "../interfaces";
import { AxiosResponse } from "axios";

interface IConferenceSectorManagerRequest {
    agentId: string;
    valor: number;
    kits: IKit[];
}

interface IConferenceRegionalManagerRequest {
    sectorId: string;
    valor: number;
    kits: IKit[];
}

interface IUpdateConferenceValores {
    valorRecebido: number;
}

interface IUpdateCorrigido {
    valorCorrigido: number;
}

interface IConferenceResponse {
    conference: IConferenceSectorManager | IConferenceRegionalManager;
    message: string;
}

interface IUpdateConferenceRequest {
    id: string;
    conferencePutModel: IUpdateConferenceValores;
}

interface IUpdateCorrigidoRequest {
    id: string;
    corrigidoPutModel: IUpdateCorrigido;
}

class ConferenceRepository {

    public GetConferenceByKitId = async (id: string): Promise<IConference> => {
        const response = await api.get<IConference>(`conference/kit/${id}`);

        return response.data;
    }

    public GetConferencesByAgentId = async (id: string): Promise<IConference[]> => {
        const response = await api.get<IConference[]>(`conference/representante/${id}`);

        return response.data;
    }

    public GetConferencesBySectorManagerId = async (id: string): Promise<IConferenceSectorManager[]> => {
        const response = await api.get<IConferenceSectorManager[]>(`conference/gerentesetor/${id}`);

        return response.data;
    }

    public CreateConferenceSectorManager = async ({ agentId, valor, kits }: IConferenceSectorManagerRequest): Promise<IConferenceResponse> => {
        const response = await api.post<IConferenceResponse>(`conference/gerentesetor`, {
            representanteId: agentId,
            valorRecebido: valor
        });

        const kitsToUpdate = kits.map(kit => ({ ...kit, pedido: null, statusKit: 6 }));

        await api.put("kit/range", kitsToUpdate);

        return response.data;
    }

    public CreateConferenceRegionalManager = async ({ sectorId, valor, kits }: IConferenceRegionalManagerRequest): Promise<IConferenceResponse> => {
        const response = await api.post<IConferenceResponse>(`conference/gerenteregional`, {
            sectorManagerId: sectorId,
            valorRecebido: valor
        });

        const kitsToUpdate = kits.map(kit => ({ ...kit, pedido: null, statusKit: 7 }));

        await api.put("kit/range", kitsToUpdate);

        return response.data;
    }

    public UpdateConference = async ({ id, conferencePutModel }: IUpdateConferenceRequest): Promise<AxiosResponse<IConferenceResponse>> => {
        const response = await api.put<IConferenceResponse>(`conference/${id}/valores`, conferencePutModel);
        return response
    }

    public UpdateValorCorrigido = async ({ id, corrigidoPutModel }: IUpdateCorrigidoRequest): Promise<AxiosResponse<IConferenceResponse>> => {
        const response = await api.put<IConferenceResponse>(`conference/${id}/corrigido`, corrigidoPutModel);
        return response
    }
}

const conferenceRepository = new ConferenceRepository();
export default conferenceRepository;
